/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import { RouterClient } from "../../../clients/routerClient";
import { Logger } from "../../../clients/logger";
import { BootTaskCallbackInterface } from "../types";
import { ServiceLauncher } from "../serviceLauncher";

/**
 * Boot task that intializes the router service.  Waits for RouterClient to be ready.
 * @private
 *
 */
export class InitializeRouterTask {
	serviceLauncher: ServiceLauncher;

	constructor(params) {
		this.serviceLauncher = params.serviceLauncher;
	}

	public start(doneCallback: BootTaskCallbackInterface) {
		const routerServiceConfig = this.serviceLauncher.getServiceConfig("router");

		this.serviceLauncher.createService(routerServiceConfig);

		Logger.system.log("initializeRouterService", routerServiceConfig);

		RouterClient.onReady(() => {
			doneCallback("initializeRouterTask", "bootTasks", "completed");
		});
	}
}
